export default class BeaconGateway {
  constructor(backend) {
    this.backend = backend;
  }

  init({ orgId }) {
    this.orgId = orgId;
  }

  get _http() {
    return this.backend.axios();
  }

  _manifestUrl(endpointId) {
    return `/api/v1/orgs/${this.orgId}/configuration/endpoints/${endpointId}/beacon-manifest`;
  }

  _bundleUrl(endpointId) {
    return `/api/v1/orgs/${this.orgId}/configuration/endpoints/${endpointId}/beacon-bundles`;
  }

  async putManifest({ endpointId }, manifest) {
    const res = await this._http.put(this._manifestUrl(endpointId), manifest);
    return res.data;
  }

  async uploadBundle({ endpointId }, file, filename) {
    const form = new FormData();
    form.append('file', file, filename);
    const res = await this._http.post(this._bundleUrl(endpointId), form);
    return res.data;
  }
}
